
@if ((!portfoliosType && !assignedToNoOfBlendedModels)) {
  <div mat-dialog-title class="red">Delete Selected Models<button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear">clear</i></button></div>
}
@if (portfoliosType || assignedToNoOfBlendedModels) {
  <div mat-dialog-title>Models Cannot Be Deleted<button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear">clear</i></button></div>
}
<mat-dialog-content>
  <div>
    <table>
      <tr>
        @if ((!portfoliosType && !assignedToNoOfBlendedModels)) {
          <td style="vertical-align: top;">
            <span class="material-icons red" style="font-size: 36px;">delete_forever</span>
          </td>
        }
        <td>
          @if (portfoliosType) {
            <div><b>{{portfolioErrorMessage}}</b></div>
          }
        </td>
        <td>
          @if ((!portfoliosType)) {
            <div style="margin-bottom: 10px;"><strong>{{blendedErrorMessage}}</strong></div>
          }
        </td>
        <td>
          @if ((!assignedToNoOfBlendedModels && !portfoliosType)) {
            <div style="margin-bottom: 10px;"><strong>{{deleteModels.length}} model selected</strong></div>
          }
        </td>

      </tr>
    </table>
  </div>
  <div>
    @if ((notAssignedToPortfolioAndBlended && !portfoliosType && !assignedToNoOfBlendedModels)) {
      <div>
        <table width="100%">
          <tr>
            <td style="vertical-align: top; width: 72px; padding: 10px 0;"><strong>Models</strong></td>
            <td style="padding: 10px; background-color: #fad1cf;">
              <div id="selectedDeleteModels"
                style="overflow-y: auto; width: 100%; min-height: 60px; max-height: 210px; border: 1px solid #CFCFCF; padding: 5px; background-color: #FFFFFF;">
                @if (deleteModels && deleteModels.length > 0) {
                  <table id="deleteModels" style="width:100%; table-layout: fixed;">
                    @for (models of deleteModels; track models) {
                      <tr>
                        <td style="width: 50%; vertical-align: top;">
                          <div class="truncate" tooltip [tooltipTitle]="models.name" [tooltipRequiresTruncation]="true" tooltipPosition="right">{{models.name}}</div>
                        </td>
                        <td style="width: 50%; vertical-align: top;">
                          <div class="truncate" tooltip [tooltipTitle]="models.description" [tooltipRequiresTruncation]="true" tooltipPosition="right">{{models.description}}</div>
                        </td>
                      </tr>
                    }
                  </table>
                }
              </div>
            </td>
          </tr>
        </table>
      </div>
    }

    @if (assignedToNoOfBlendedModels && !portfoliosType) {
      <div>
        <table width="100%">
          <tr>
            <td style="background-color: #0c0c0c;">
              <div id="selectedDeleteBlendedModels"
                style="overflow-y: auto; width: 100%; min-height: 60px; max-height: 210px; border: 1px solid #CFCFCF; padding: 5px; background-color: #FFFFFF;">
                @if (blendedDeleteModels && blendedDeleteModels.length > 0) {
                  <table id="blendedDeleteModels" style="width:100%; table-layout: fixed;">
                    @for (blended of blendedDeleteModels; track blended) {
                      <tr>
                        <td style="width: 50%; vertical-align: top;">
                          <div class="truncate" tooltip [tooltipTitle]="blended[0]" [tooltipRequiresTruncation]="true" tooltipPosition="right">{{blended[0]}}</div>
                        </td>
                        <td style="width: 50%; vertical-align: top;">
                          <div class="truncate" tooltip [tooltipTitle]="blended[1]" [tooltipRequiresTruncation]="true" tooltipPosition="right">{{blended[1]}}</div>
                        </td>
                      </tr>
                    }
                  </table>
                }
              </div>
            </td>
          </tr>
        </table>
      </div>
    }

    @if (portfoliosType) {
      <div>
        <table width="100%">
          <tr>
            <td style="background-color: #0c0c0c;">
              <div id="selectedDeletePortfolioModels"
                style="overflow-y: auto; width: 100%; min-height: 60px; max-height: 210px; border: 1px solid #CFCFCF; padding: 5px; background-color: #FFFFFF;">
                @if (portfoliodeleteModels && portfoliodeleteModels.length > 0) {
                  <table id="portfoliodeleteModels" style="width:100%; table-layout: fixed;">
                    @for (portfolio of portfoliodeleteModels; track portfolio) {
                      <tr>
                        <td style="width: 50%; vertical-align: top;">
                          <div class="truncate" tooltip [tooltipTitle]="portfolio[0]" [tooltipRequiresTruncation]="true" tooltipPosition="right">{{portfolio[0]}}</div>
                        </td>
                        <td style="width: 50%; vertical-align: top;">
                          <div class="truncate" tooltip [tooltipTitle]="portfolio[1]" [tooltipRequiresTruncation]="true" tooltipPosition="right">{{portfolio[1]}}</div>
                        </td>
                      </tr>
                    }
                  </table>
                }
              </div>
            </td>
          </tr>
        </table>
      </div>
    }
  </div>
</mat-dialog-content>
@if ((portfoliosType || assignedToNoOfBlendedModels)) {
  <mat-dialog-actions>
    <button id="closeButton" (click)="close()" class="btn-medium-primary green">Close</button>
  </mat-dialog-actions>
}

<!-- <mat-dialog-actions *ngIf="(assignedToNoOfBlendedModels && !portfoliosType)">
<button id="closeButton" (click)="close()" class="btn-medium-secondary grey">Close</button>
<button disabled="disabled" mat-button class="btn-medium-primary red" (click)="deleteSelectedModel()"><span class="material-icons" style="font-size: 16px; margin-top: -3px;">delete_forever</span>&nbsp;Delete</button>
</mat-dialog-actions> -->

@if ((notAssignedToPortfolioAndBlended &&(!assignedToNoOfBlendedModels && !portfoliosType))) {
  <mat-dialog-actions>
    <button id="closeButton" (click)="close()" class="btn-medium-secondary grey">Cancel</button>
    <button mat-button class="btn-medium-primary red" (click)="deleteSelectedModel()"><span class="material-icons" style="font-size: 16px; margin-top: -3px;">delete_forever</span>&nbsp;Delete</button>
  </mat-dialog-actions>
}
